export default {
      id: "icon-bubble-usage",
      viewBox: "0 0 131 87",
      url: __webpack_public_path__ + "icons.svg#icon-bubble",
      toString: function () {
        return this.url;
      }
    }